<app-form (submit)="updateLinkedContract()">
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">
                <span>{{ isNewRecord ? 'Link contract' : 'Edit contract period' }}</span>
            </h3>
        </div>
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-12 notranslate">
                    <app-form-field label="Contract">
                        <app-search [minCharacters]="0" [(ngModel)]="contract" required
                                    [searchFunction]="getNonDefaultContracts" dataKey="contract.contractData.name"
                                    [inputFormatter]="refDataUtils.contractsFormatter"
                                    (ngModelChange)="onContractSelected($event)"
                                    [disabled]="!isNewRecord || !!data.contract"
                                    placeholder="Search for a contract"></app-search>
                    </app-form-field>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <app-contract-range [dateRange]="data.linkedContract.dateRange"
                                        [isReadOnly]="false"></app-contract-range>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between">
            <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
            <div>
                <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</app-form>

